<template>
  <div>
    <!--begin::Body-->
    <div class="kt-login__body">
      <!--begin::Signin-->
      <div class="kt-login__form">
        <div class="kt-login__title">
          <p v-if="cliente.caminhoVisualizacao" style="text-align: center">
            <img :src="cliente.caminhoVisualizacao" style="max-height: 80px" />
          </p>
          <p v-if="!cliente.caminhoVisualizacao" style="text-align: center">
            <img :src="cliente.logo" style="max-height: 80px" />
          </p>
          <br />
          <hr />
          <br />
          <h3>Acessar</h3>
        </div>
        <!--begin::Form-->
        <b-form class="kt-form" @submit.stop.prevent="onSubmit">
          <div
            role="alert"
            v-bind:class="{ show: errors.length }"
            class="alert fade alert-danger"
          >
            <div class="alert-text" v-for="(error, i) in errors" :key="i">
              {{ error }}
            </div>
          </div>

          <b-form-group>
            <b-form-input
              placeholder="TAG"
              id="tagUrl"
              :disabled="cliente.id != null"
              name="tagUrl"
              v-model="$v.form.tagUrl.$model"
              :state="validateState('tagUrl')"
              aria-describedby="tagUrl-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="email-feedback">
              TagURL é obrigatório
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <b-form-input
              placeholder="Email"
              id="example-input-1"
              name="email"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="email-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="email-feedback">
              Email é obrigatório e um endereço de email válido.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="example-input-group-2"
            label=""
            label-for="example-input-2"
          >
            <b-form-input
              placeholder="Senha"
              type="password"
              id="example-input-2"
              name="example-input-2"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              aria-describedby="input-2-live-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="input-2-live-feedback">
              Password é obrigatório.
            </b-form-invalid-feedback>
          </b-form-group>

          <!--begin::Action-->
          <div class="kt-login__actions">
            <v-row justify="center">
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <a
                    class="kt-link kt-login__link-forgot"
                    :disabled="cliente.id === null"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ $t("AUTH.FORGOT.TITLE") }}
                  </a>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Esqueci Minha Senha</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            label="E-mail"
                            required
                            v-model="emailEsqueci"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="dialog = false">
                      Cancelar
                    </v-btn>
                    <v-btn
                      type="button"
                      color="blue darken-1"
                      text
                      @click="novaSenha"
                    >
                      Solicitar Nova Senha
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
            <button
              id="kt_submit"
              class="btn btn-primary btn-elevate kt-login__btn-primary"
            >
              {{ $t("AUTH.LOGIN.BUTTON") }}
            </button>
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Form-->
      </div>
      <!--end::Signin-->
    </div>
    <!--end::Body-->
  </div>
</template>

<style lang="scss" scoped>
.kt-spinner.kt-spinner--right:before {
  right: 8px;
}
</style>

<script>
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/store/auth.module";
import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      form: {
        tagUrl: null,
        email: "",
        password: "",
      },
      cliente: {
        id: null,
        logo: "https://sccgedqas.blob.core.windows.net/publico/big-core.png",
      },
      dialog: false,
      emailEsqueci: "",
    };
  },
  validations: {
    form: {
      tagUrl: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const tagUrl = this.$v.form.tagUrl.$model.trim();
      const email = this.$v.form.email.$model.trim();
      const password = this.$v.form.password.$model.trim();

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add(
        "kt-spinner",
        "kt-spinner--light",
        "kt-spinner--right"
      );

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { email, senha: password, tagUrl })
          // go to which page after successfully login
          .then((result) => {
            if (result.success) {
              window.localStorage.setItem(
                "cliente",
                JSON.stringify(result.data.cliente)
              );
              if (
                PermissoesService.verificarAcesso(
                  Modulo.Dashboard,
                  Permissoes.Visualizar
                )
              )
                this.$router.push({ name: "dashboard" });
              else this.$router.push({ name: "index" });
            } else SweetAlert.sweetAlertError(result.errors);
          })
          .finally(() => {
            submitButton.classList.remove(
              "kt-spinner",
              "kt-spinner--light",
              "kt-spinner--right"
            );
          });
      }, 2000);
    },

    novaSenha() {
      let self = this;
      if (this.emailEsqueci.length > 0) {
        return new Promise((resolve) => {
          ApiService.put("usuario/updatepassword", {
            email: this.emailEsqueci,
          }).then(({ data }) => {
            if (data.success) {
              resolve(data);

              self.dialog = false;
              Swal.fire({
                position: "center",
                icon: "success",
                title:
                  "Solicitação de Nova Senha Realizada com Sucesso!<br>Um E-mail foi encaminhado com os novos dados de acesso.",
                showConfirmButton: false,
                timer: data.success == true ? 5000 : 1500,
              });
            } else SweetAlert.sweetAlertError(data.errors);
          });
        });
      }
    },
  },
  computed: {
    ...mapState({
      errors: (state) => {
        return state.auth.errors ? state.auth.errors : [];
      },
    }),
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/bg/bg-4.jpg";
    },
  },
  async mounted() {
    window.localStorage.clear();
    sessionStorage.clear();

    if (this.$route.params.cliente) {
      this.form.tagUrl = this.$route.params.cliente;

      const { data: result } = await ApiService.get(
        "cliente/getbytagurl/" + this.form.tagUrl
      );

      if (!result.success) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Cliente não localizado",
        });

        return;
      }

      this.cliente = result.data;
      window.localStorage.setItem("cliente", JSON.stringify(this.cliente));
    }
  },
};
</script>
